// Array of professional packaging-inspired neutral tones
export const PASTRY_COLORS = [
  "#F7EDD0",
  "#F5F5F0",
  "#EDF0F2",
  "#F0EDE8",
  "#EEF2EE",
  "#F2EFE8",
  "#EEEDF5",
  "#F0F4F5",
  "#F5F0ED",
];
